const ScoreEntity = (backClient) => ({
  getSocialScore: async () => await backClient.get(`/api/social_score`),
  getEnvironmentalScore: async () => await backClient.get(`/api/env_score`),
  getProfitScore: async () => await backClient.get(`/api/profit_score`),
  getScore: async () => await backClient.get(`/api/score`),
  getOdd13GhgEmissionsFactorAverage: async () =>
    await backClient.get(`/api/score/odd13/kpi/ghg_emissions_factor_average`),
  getOdd13GhgEmissionsPerServiceAverage: async () =>
    await backClient.get(
      `/api/score/odd13/kpi/ghg_emissions_per_service_average`
    ),
  socialPeopleInventoryScore: async () =>
    await backClient.get(`/api/social_people_inventory_score`),
  getOdd13GhgEmissionsBreakdownByAllocation: async () =>
    await backClient.get(
      `/api/score/odd13/charts/ghg_emissions_breakdown_by_allocation`
    ),
  getOdd13GhgEmissionsBreakdownByProvider: async () =>
    await backClient.get(
      `/api/score/odd13/charts/ghg_emissions_breakdown_by_provider`
    ),
  getOdd13GhgEmissionsBreakdownByCategory: async () =>
    await backClient.get(
      `/api/score/odd13/charts/ghg_emissions_breakdown_by_category`
    ),
  websiteScore: async () => await backClient.get(`/api/website_scores/score`),
  websiteScores: async () => await backClient.get(`/api/website_scores`),
  socialReference: async () => await backClient.get(`/api/social_reference`),
  compute: async () => await backClient.post(`/api/scores/compute`),
  compare: async (node_ids) =>
    await backClient.get(`/api/compare_score`, { params: { node_ids } }),
  compareWebsites: async (node_ids) =>
    await backClient.get(`/api/compare_score/websites`, {
      params: { node_ids },
    }),
})

export default ScoreEntity
